import { AppRootState } from 'app/store'

export const selectTasks = (state: AppRootState) => state.exam.tasks
export const selectCurrentTask = (state: AppRootState) =>
  state.exam.tasks[state.exam.currentTaskNumber]
export const selectCurrentTaskNumber = (state: AppRootState) => state.exam.currentTaskNumber
export const selectResults = (state: AppRootState) => state.exam.results
export const selectCurrentResult = (state: AppRootState) =>
  state.exam.results[state.exam.currentTaskNumber]
export const selectIsFinished = (state: AppRootState) => state.exam.isFinished

export const selectExamStatus = (state: AppRootState) => state.exam.status
